import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { DonatePage } from '../../pages/donate-page'
import { Playground } from '../../pages/playground-page'
import { LoginPage } from '../../pages/login-page'
import { CharityPage } from '../../pages/charity-page'
import { AccountLayout } from '../../pages/account-page'
import { ActivatePage } from '../../pages/activate-page'
import { HomePage } from '../../pages/home-page'
import { CheckoutPage } from '../../pages/checkout-page'
import { ListedItemDetailsPage } from '../../pages/listed-item-details-page'
import { useSelector } from 'react-redux'
import {
  selectIsAuthenticated,
  selectCheckedAuth,
} from '../../store/auth/selectors'
import { CircularProgress, Container, Grid } from '@material-ui/core'
import { OrderPage } from '../../pages/order-page'
import { ShopPage } from '../../pages/shop-page'
import { MyListedItemsPage } from '../../pages/my-listed-items-page'
import { OwnItemDetailsPage } from '../../pages/own-item-details-page'
import { DraftItemsPage } from '../../pages/draft-items-page/draft-items-page.component'
import { NotFoundPage } from '../../pages/not-found-page'
import { AboutPage } from '../../pages/about-page'
import { PurchasedItemsPage } from '../../pages/purchased-items-page'
import { OrdersListPage } from '../../pages/orders-list-page/orders-list-page.component'
import { Alert } from '@material-ui/lab'
import { useAuthRedirect } from '../../hooks/use-auth-redirect'
import { useTranslation } from 'react-i18next'
import { ModerationPage } from '../../pages/moderation-page'
import { ModeratorViewListedItemDetailsPage } from '../../pages/moderator-view-listed-item-details-page'
import { NotificationsPage } from '../../pages/notifications-page'
import { NonProfitsPage } from '../../pages/non-profits-page/non-profit-page'
import { NonprofitDetailsPage } from '../../pages/non-profit-details-page/non-profit-details-page'

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/search" element={<HomePage />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/donate" element={<DonatePage />} />
      <Route path="/donate/:nonprofitId" element={<DonatePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/charity" element={<CharityPage />} />

      <Route
        path="/notifications"
        element={
          <AuthRequired
            basePath="/notifications"
            isAuthComponent={<NotificationsPage />}
          />
        }
      />

      <Route path="/nonprofit-catalog" element={<NonProfitsPage />} />
      <Route path="/external/:externalId" element={<NonprofitDetailsPage />} />
      <Route
        path="/account/*"
        element={
          <AuthRequired
            basePath="/account"
            isAuthComponent={<AccountLayout />}
          />
        }
      />
      <Route
        path="/checkout/:urlItemId/:urlDeliveryType"
        element={
          <AuthRequired
            basePath="/checkout"
            isAuthComponent={<CheckoutPage />}
          />
        }
      />
      <Route
        path="/listed-items/buyer"
        element={
          <AuthRequired
            basePath="/listed-items/buyer"
            isAuthComponent={<PurchasedItemsPage />}
          />
        }
      />
      <Route path="/listed-items/:itemId" element={<ListedItemDetailsPage />} />
      <Route
        path="/moderator-view-listed-items/:itemId"
        element={<ModeratorViewListedItemDetailsPage />}
      />
      <Route
        path="/orders"
        element={
          <AuthRequired
            basePath="/orders"
            isAuthComponent={<OrdersListPage />}
          />
        }
      />
      <Route
        path="/selling/order/:orderId"
        element={
          <AuthRequired basePath="/selling" isAuthComponent={<OrderPage />} />
        }
      />
      <Route
        path="/my-listed-items/:itemId"
        element={
          <AuthRequired
            basePath="/my-listed-items"
            isAuthComponent={<OwnItemDetailsPage />}
          />
        }
      />
      <Route
        path="/my-listed-items"
        element={
          <AuthRequired
            basePath="/my-listed-items"
            isAuthComponent={<MyListedItemsPage />}
          />
        }
      />
      <Route
        path="/draft-items"
        element={
          <AuthRequired
            basePath="/draft-items"
            isAuthComponent={<DraftItemsPage />}
          />
        }
      />
      <Route path="user">
        <Route path="activate/:token" element={<ActivatePage />} />
        <Route path="email-verification/:token" element={<HomePage />} />
      </Route>
      <Route path="/about" element={<AboutPage />} />
      <Route path='/moderation' element={<ModerationPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

type AuthCheckerType = {
  isAuthComponent: React.ReactElement
  basePath: string
}

//AuthChecker - Component for Auth Check
const AuthRequired: React.FC<AuthCheckerType> = (props) => {
  const auth = useSelector(selectIsAuthenticated)
  const checkedAuth = useSelector(selectCheckedAuth)
  const { isAuthComponent, basePath } = props

  if (!checkedAuth) {
    return <LoaderRenderer />
  }

  return (
    <>
      {auth ? (
        isAuthComponent
      ) : (
        <Container>
          {' '}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <AuthNotification url={basePath} />
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  )
}

const LoaderRenderer: React.FC = () => {
  return <CircularProgress />
}

type AuthNotificationProps = {
  url: string
}

const AuthNotification: React.FC<AuthNotificationProps> = ({ url }) => {
  const { authRedirectHandle } = useAuthRedirect()
  const { t } = useTranslation()

  return (
    <div>
      <Alert style={{ marginTop: '20px' }} severity="warning">
        {t('isAuthComponent.notLoggedIn')}{' '}
        <span
          style={{
            cursor: 'pointer',
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
          onClick={(e) => authRedirectHandle(e, url, url)}
        >
          {t('isAuthComponent.login')}
        </span>{' '}
        {t('isAuthComponent.toContinue')}
      </Alert>
    </div>
  )
}
